import { Text } from '@/shared/ui';
import type { CascaderOption } from '../helpers';
import { getColumnOptions } from '../utils/path-utils';
import { CascaderColumn } from './CascaderColumn';

type CascaderColumnsProps = {
  processedOptions: CascaderOption[];
  activePath: string[];
  selectedPaths: string[][];
  hoveredIndex: number[];
  multiple: boolean;
  onlyLeafSelectable: boolean;
  columnCount: number;
  onCheckboxToggle: (option: CascaderOption, level: number) => void;
  onNavigate: (option: CascaderOption, level: number) => void;
  onMouseEnter: (level: number, idx: number) => void;
  onMouseLeave: (level: number) => void;
};

export const CascaderColumns = ({
  processedOptions,
  activePath,
  selectedPaths,
  hoveredIndex,
  multiple,
  onlyLeafSelectable,
  columnCount,
  onCheckboxToggle,
  onNavigate,
  onMouseEnter,
  onMouseLeave,
}: CascaderColumnsProps) => {
  if (processedOptions.length === 0) {
    return (
      <div className="flex min-h-[60px] min-w-[160px] items-center justify-center p-4">
        <Text color="muted">選択肢がありません</Text>
      </div>
    );
  }

  return (
    <div
      // 親 PopoverContent が flex container かつ boundary 配下で max-height 制限されている場合、
      // flex-1 + min-h-0 で外側内に自動収縮する。boundary なし時は max-h-[300px] が上限。
      className="flex max-h-[300px] min-h-0 flex-1 gap-1"
      onWheel={(e) => e.stopPropagation()}
    >
      {Array.from({ length: columnCount }, (_, i) => i).map((level) => {
        const columnOptions = getColumnOptions(level, activePath, processedOptions);
        if (columnOptions.length === 0) return null;
        const isLastColumn = level === columnCount - 1;

        return (
          <CascaderColumn
            key={level}
            level={level}
            options={columnOptions}
            isLastColumn={isLastColumn}
            activePath={activePath}
            selectedPaths={selectedPaths}
            hoveredIndex={hoveredIndex}
            multiple={multiple}
            onlyLeafSelectable={onlyLeafSelectable}
            onCheckboxToggle={onCheckboxToggle}
            onNavigate={onNavigate}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        );
      })}
    </div>
  );
};
